// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eC7Xs{position:relative;width:calc(100% + 8px);min-width:0;margin-right:-8px}.UoXmq{width:100%;min-width:0;overflow-x:auto;overflow-y:visible;padding:12px 8px 12px 0;scrollbar-width:none;-ms-overflow-style:none}.UoXmq::-webkit-scrollbar{display:none}.UZls2{position:absolute;top:12px;bottom:12px;width:88px;pointer-events:none;opacity:0;transition:opacity .2s ease;z-index:1}.e8E8v{opacity:1}.C5reU{left:0;background:linear-gradient(to right, var(--color-bg-base, #f4f5f8) 0%, rgba(244, 245, 248, 0) 100%)}.hEikR{right:0;background:linear-gradient(to left, var(--color-bg-base, #f4f5f8) 0%, rgba(244, 245, 248, 0) 100%)}.xoEcs{position:absolute;top:50%;transform:translateY(-50%);z-index:2;width:40px;height:40px;padding:0;margin:0;border-radius:50%;background:#fff;border:1px solid #d4d4e0;color:#bfbfd0;display:flex;align-items:center;justify-content:center;cursor:pointer;opacity:0;pointer-events:none;transition:opacity .2s ease,color .15s ease,border-color .15s ease}.xoEcs:hover:not(:disabled),.xoEcs:active:not(:disabled){color:#282863;border-color:#282863}.xoEcs:focus-visible{outline:2px solid #282863;outline-offset:2px}.LfIsT{opacity:1;pointer-events:auto}.fhUJR{left:20px}.mtNBc{right:20px}.OYeg8{display:flex;flex-direction:row;flex-wrap:nowrap;width:100%;gap:16px}.hNmA8{flex:1 1 240px;min-width:240px}._4VDC{display:flex !important;flex-direction:row !important;flex-wrap:nowrap !important;grid-template-columns:unset !important;grid-template-rows:unset !important;grid-auto-flow:unset !important;grid-auto-columns:unset !important;gap:16px !important;width:100%;justify-content:start;overflow:visible !important}.B4bdd{flex:1 1 240px !important;min-width:240px !important;touch-action:pan-x !important}.EVQp5{width:100%;height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"container": `eC7Xs`,
	"root": `UoXmq`,
	"fade": `UZls2`,
	"fadeVisible": `e8E8v`,
	"fadeLeft": `C5reU`,
	"fadeRight": `hEikR`,
	"scrollButton": `xoEcs`,
	"scrollButtonVisible": `LfIsT`,
	"scrollButtonLeft": `fhUJR`,
	"scrollButtonRight": `mtNBc`,
	"staticStrip": `OYeg8`,
	"staticItem": `hNmA8`,
	"draggableGridOverride": `_4VDC`,
	"draggableGridItem": `B4bdd`,
	"metricCardItemMarker": `EVQp5`
};
export default ___CSS_LOADER_EXPORT___;
